// @ts-check
// ====== Costanti globali ======
const STORAGE_KEY = 'portale-mase-data-v3';
const STATUS_OPTIONS = [
  '',
  'Sì',
  'No',
  'Richieste',
  'Da richiedere',
  'Da eliminare',
  'Eliminato',
  'N/A'
];
const ACTION_STATUSES = ['Da richiedere', 'Richieste', 'Da eliminare'];
const ADMIN_VIEWS = new Set(['azioni', 'scadenze', 'storico', 'sicurezza', 'impostazioni']);
const PERIMETRI = ['Azure', 'M365', 'Power App', 'Whistleblowing', 'IT'];

Object.assign(globalThis, { STORAGE_KEY, STATUS_OPTIONS, ACTION_STATUSES, ADMIN_VIEWS, PERIMETRI });
export {};
